/**
 * 목록 필터(칩 줄·시트·팝업) 공용 색·크기 — 세미나 목록 시안(2026-09-29 승인)의 값.
 * 채용 목록 등 다른 목록에 붙일 때도 같은 값을 쓴다.
 */
export const filterTokens = {
    color: {
        text: '#1F2A28',
        textSub: '#4F5B58',
        textMuted: '#66736F',
        border: '#D3DBD8',
        divider: '#E3E8E6',
        surface: '#FFFFFF',
        accent: '#5A9B96',
        selectedBg: '#E6F1EF',
        selectedText: '#2F6B66',
        disabledBg: '#C9D6D3',
        dim: 'rgba(20, 30, 28, 0.45)',
    },
    chipHeight: 36,
    optionHeight: 38,
    sheetRadius: 20,
} as const;

/** 이 폭 이하면 폰 화면 — 시트, 넘으면 칩 아래 팝업 */
export const FILTER_MOBILE_MAX_WIDTH_PX: number = 768;
